import { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Council, Society } from 'types';
import { useTranslate } from 'hooks/useTranslate';

import sizes from 'constants/sizes';
import actionTypes from 'constants/actionTypes';

import AddCouncil from 'modules/_shared/components/Modals/AddCouncil';
import EditButton from 'modules/_shared/components/Buttons/EditButton';
import { setModal } from 'modules/_shared/redux/modalActions';

import { State } from 'redux/initialState';
import { useCouncilBasicInfoCard } from '../hooks/useCouncilBasicInfoCard';

type CouncilMembersBasicInfoCardProps = {
  council: Council;
  society: Society;
  isAdminView: boolean;
};

const CouncilMembersBasicInfoCard: FC<CouncilMembersBasicInfoCardProps> = ({
  council,
  society,
  isAdminView,
}) => {
  const { t } = useTranslate();
  const dispatch = useDispatch();
  const isAdmin = useSelector((state: State) => state.society?.role?.isAdmin);
  const { data: items } = useCouncilBasicInfoCard({
    council,
    society,
    isAdmin,
  });

  return (
    <section className="council-member-basic-info-card col mb-5 px-0">
      <div className="nk-block-head">
        <div className="nk-block-head-content d-flex justify-content-between align-items-center">
          <h5 className="nk-block-title title mb-0">{t('BasicData')}</h5>

          {isAdminView && (
            <EditButton
              className=""
              action={() =>
                dispatch(
                  setModal(
                    <AddCouncil
                      action={actionTypes.EDIT as keyof typeof actionTypes}
                      council={council}
                      size={sizes.XL}
                    />
                  )
                )
              }
            />
          )}
        </div>
      </div>

      <div className="card rounded-xl">
        <ul className="data-list is-compact">
          {items.map(({ title, value }) => (
            <li className="data-item" key={title}>
              <div className="data-col">
                <div className="data-label w-100px">{title}</div>
                <div className="data-value">{value}</div>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default CouncilMembersBasicInfoCard;
